import { createAction } from 'lib/reduxUtils';

export const UPDATE_CHAPTER_USER_METADATA = 'entities/chapters/updateChapterUserMetadata';
export const updateChapterUserMetadata = createAction(UPDATE_CHAPTER_USER_METADATA);
